import { forwardRef } from "react";
import { trackCta } from "@/lib/analytics/cta";

export interface TrackedAnchorProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  /** Stable slug for what this CTA does (unchanged when copy changes). */
  ctaId: string;
  /** Where on the site the CTA was clicked (e.g. `header`, `footer`). */
  ctaLocation: string;
}

/**
 * A native `<a>` that fires a `cta_click` event before its default action.
 * Use for external / cross-subdomain / mailto / tel / social links that a
 * react-router `<Link>` can't express. All other props pass straight through;
 * `destination` is taken from `href`.
 */
export const TrackedAnchor = forwardRef<HTMLAnchorElement, TrackedAnchorProps>(
  ({ ctaId, ctaLocation, href, onClick, ...rest }, ref) => {
    const handleClick: React.MouseEventHandler<HTMLAnchorElement> = (event) => {
      trackCta({ cta_id: ctaId, location: ctaLocation, destination: href ?? null });
      onClick?.(event);
    };
    return <a ref={ref} href={href} onClick={handleClick} {...rest} />;
  },
);
TrackedAnchor.displayName = "TrackedAnchor";
